import { apiClient } from './api';

type Pagination = {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
};

export type UsersListResponse = {
  data: any[];
  pagination: Pagination;
};

export type InviteUserPayload = {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  role: string;
  supplierId?: number | null;
};

export const usersService = {
  getList: (params: URLSearchParams) =>
    apiClient.get<UsersListResponse>(`/users?${params.toString()}`),

  getById: (id: string | number) => apiClient.get<any>(`/users/${id}`),

  save: (id: string | number | null, payload: Record<string, unknown>) =>
    id
      ? apiClient.put<any, Record<string, unknown>>(`/users/${id}`, payload)
      : apiClient.post<any, Record<string, unknown>>('/users', payload),

  invite: (payload: InviteUserPayload) =>
    apiClient.post<{ success: boolean; message: string }, InviteUserPayload>('/users/invite', payload),

  remove: (id: string | number) =>
    apiClient.delete<{ id: number; message: string }>(`/users/${id}`),

  approve: (id: string | number) =>
    apiClient.post<{ id: number; message: string }>(`/users/${id}/approve`),

  reject: (id: string | number) =>
    apiClient.post<{ id: number; message: string }>(`/users/${id}/reject`),

  approveInvitation: (id: string | number) =>
    apiClient.post<{ id: number; message: string }>(`/users/invitations/${id}/approve`),

  rejectInvitation: (id: string | number) =>
    apiClient.post<{ id: number; message: string }>(`/users/invitations/${id}/reject`),
};
